module.exports = __webpack_public_path__ + "assets/img/00040.bcd6ea9d.png";